var map = {
	"./npmstepno1.avif": 1760,
	"./npmstepno2.avif": 2197,
	"./npmstepno3.avif": 6102,
	"./npmstepno4.avif": 7339,
	"./npmstepno5.avif": 1884,
	"./npmstepno6.avif": 1329
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7871;